import { Button, Modal } from "antd";
import {ChatService} from "../../service/ChatService";
import "./InUseModal.scss";

export interface InUseModalProps {
  isVisible: boolean;
  onClose: () => void;
  onOpenAnyway: () => void;
}

export function InUseModal({ isVisible, onClose, onOpenAnyway }: InUseModalProps) {
    function useChat() {
        ChatService.newMessage();
    }

    return (
        <Modal
        className={"clean one in-use-modal"}
        visible={isVisible}
        onCancel={() => onClose()}
        >
        <header>
            <h2>Design is in use</h2>
        </header>

        <p>
            This design is being edited by a different member of your team. <br/>
            <span className={"chat-link"} onClick={useChat}>Chat with us</span> for access.
        </p>

        <footer>
            <Button className={"primary"} size={"large"} onClick={onClose}>
            Okay
            </Button>
            <Button className={"cancel"} size={"large"} onClick={onOpenAnyway}>
            Open Anyway
            </Button>
        </footer>
        </Modal>
    );
}
